var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00683594H513V341.96H0V-0.00683594Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 57.0044H513V114.016H0V57.0044Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 114.016H513V171.027H0V114.016Z",
    fill: "#D32300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.038H513V285.049H0V228.038Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 284.949H513V341.96H0V284.949Z",
    fill: "#D32300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 251.884C301.157 251.884 337.358 215.683 337.358 171.027C337.358 126.37 301.157 90.1689 256.5 90.1689C211.844 90.1689 175.643 126.37 175.643 171.027C175.643 215.683 211.844 251.884 256.5 251.884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.958 127.742C235.86 126.339 215.32 125.738 215.32 125.738C217.023 123.233 233.756 115.218 233.756 115.218C233.756 115.218 232.854 109.206 236.461 105.399L231.952 95.5795C231.952 95.5795 238.966 92.1729 250.388 92.1729C261.81 92.1729 270.327 99.1865 271.429 105.298L265.016 108.705C264.916 113.414 266.72 120.328 260.708 126.039C254.797 131.75 252.392 132.952 252.191 144.876C252.191 148.783 254.496 153.092 261.009 156.598C278.443 165.917 299.684 184.854 305.696 190.565C311.808 196.276 310.806 209.802 308.301 215.814C305.796 221.826 296.177 230.142 293.973 229.44C291.769 228.839 295.175 220.222 290.466 217.818C290.466 217.818 281.549 210.203 273.633 218.419C265.718 226.635 273.433 243.668 277.541 246.474C281.649 249.279 279.244 251.483 275.637 251.483H247.482C243.675 251.483 242.072 249.179 245.579 246.474C253.193 242.666 258.003 231.144 252.993 226.134C248.083 221.224 234.657 227.637 231.451 232.446C228.646 235.252 222.634 236.053 218.526 231.044C214.418 226.034 214.418 220.623 217.424 218.519C224.437 213.71 217.424 218.519 217.524 218.419C217.524 218.419 229.447 209.802 247.482 209.401C251.39 209.401 252.292 207.197 249.687 204.592C249.687 204.592 218.726 177.138 221.532 160.306C224.538 141.97 241.571 133.954 234.958 127.742C234.958 127.742 233.655 125.939 234.958 127.742Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/UG.fe08569cb984c62eacb9fc7bca313164.svg";
export { ForwardRef as ReactComponent };